import * as React from 'react';
import { Popover as HeadlessPopover } from '@headlessui/react';
import { cn } from '../../lib/utils';

export const Popover = HeadlessPopover;
export const PopoverTrigger = HeadlessPopover.Button;

export const PopoverContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <HeadlessPopover.Panel
    ref={ref}
    className={cn(
      'z-[120] mt-2 w-72 rounded-lg border border-stone-300 bg-white p-3 shadow-xl',
      className
    )}
    {...props}
  />
));
PopoverContent.displayName = 'PopoverContent';
